<!-- calendar source: https://codesandbox.io/s/monthly-calendar-vue-wdv9y -->

<template>
  <div>
    <vs-row>
      <vs-col vs-lg="6" vs-sm="12">
        <menus/>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12">
        <categories/>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-lg="6" vs-sm="12">
        <addons/>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12">
        <labels/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import categories from "@/views/admin/categories";
import labels from "@/views/admin/labels";
import menus from "@/views/admin/menus";
import addons from "@/views/admin/addons";

export default {
  name: "item_options",
  data() {
    return {}
  },
  components: {categories, labels, menus, addons},
  methods: {}
}
</script>